export default function () {
  let menuButton = document.querySelector(".hamburger");
  let headerCont = document.querySelector(".header-container");
  let nav = document.querySelector("#section-megamenu");

  menuButton.onclick = function () {
    menuButton.classList.toggle("is-active");
    nav.classList.toggle("active");
    headerCont.classList.toggle("active");
  };
}
